module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-411x93@1x.b7fac3c2.jpg";